import { atom } from 'recoil';
import { InterpolatedImageInfo } from '~/domain/services/dicomProcessor';

export type InterpolationAcknowledgementState = {
    open: boolean;
    images: InterpolatedImageInfo[];
};

export const interpolationAcknowledgementState =
    atom<InterpolationAcknowledgementState>({
        key: 'interpolationAcknowledgementState',
        default: { open: false, images: [] },
    });

// Resolver for the in-flight acknowledgement promise. Held outside
// Recoil because functions are not serializable; the visible state
// (open + image list) lives in the atom above.
let pendingResolver: (() => void) | null = null;

export function setPendingInterpolationResolver(
    resolver: (() => void) | null
): void {
    pendingResolver = resolver;
}

export function resolvePendingInterpolationAcknowledgement(): void {
    const resolver = pendingResolver;
    pendingResolver = null;
    resolver?.();
}
